import { saveLastTenant } from "../services/api-server/user";

/**
 * Switches to a tenant: stores it for this browser, remembers it on the
 * server for the next sign-in, then runs `go` (the reload into the tenant).
 * A failed save is logged and the switch still happens.
 */
export const switchTenant = (tenantKey: string, go: () => void) => {
	localStorage.setItem("currentTenantKey", tenantKey);
	saveLastTenant(tenantKey)
		.catch((error: any) => {
			console.log(error);
		})
		.finally(go);
};
